// extracted by mini-css-extract-plugin
module.exports = {"aboutus":"Index_aboutus_3-GWN"};